import {
  Button,
  CloseIcon,
  CheckIcon,
  CloseCircleIcon,
  Card,
  CardHeader,
} from "@forge/common";
import React from "react";
import Title from "../../common/components/title-container/title"; // Adjust the path as needed
import {
  BodyText,
  NormalText,
} from "../../common/components/title-container/LText"; // Adjust the path as needed
import { btnResponsive } from "../../common/utils/helper";

interface HeaderComponentProps {
  title: string;
  onCancel: () => void;
}

export const HeaderComponent: React.FC<HeaderComponentProps> = ({
  title,
  onCancel,
}) => {
  return (
    <div className="flexContainer justifyContent-spaceBetween alignItems-center pt-2 mt-4">
      <NormalText
        title={title}
        className={`text-lg ${btnResponsive("text-lg")} font-bold`}
      />
      <CloseIcon
        onClick={onCancel}
        className={`cursor-pointer text-[#E0E0E0] font-bold text-lg ${btnResponsive(
          "text-lg"
        )}`}
      />
    </div>
  );
};

export const FooterComponent = ({
  onCancel,
  onTrigger,
  btnText,
  btnText1,
  disabled,
}: {
  onCancel: () => void;
  onTrigger: () => void;
  btnText?: string;
  btnText1?: string;
  disabled?: boolean;
}) => {
  return (
    <div className={"flexContainer justifyContent-center gap-3 mt-5  mb-5"}>
      {btnText && (
        <Button
          variant="secondary"
          size="regular"
          onClick={onCancel}
          className={`text-base font-w-700 mr-4 uppercase ${btnResponsive()}`}
        >
          {btnText}
        </Button>
      )}
      {btnText1 && (
        <Button
          variant="primary"
          size="regular"
          className={`text-base font-w-700 mr-4 uppercase ${btnResponsive()}`}
          onClick={onTrigger}
          disabled={disabled}
        >
          {btnText1}
        </Button>
      )}
    </div>
  );
};

export const deletePopup = ({
  title,
  description,
  description1,
  btnText1,
  btnText,
  onCancel,
  onTrigger,
  disabled,
}: {
  title: string;
  description?: string;
  description1?: string;
  btnText1?: string;
  btnText?: string;
  onCancel: () => void;
  onTrigger: () => void;
  disabled?: boolean;
}) => {
  return (
    <div className="flexContainer flexDirection-column h-[310px] w-[459px] xl-high:w-[550px] xl-high:h-[400px]">
      <HeaderComponent title={title} onCancel={onCancel} />
      <div className="mt-4 overflowY-auto h-[60vh] w-[400px]">
        <NormalText
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[32px]  font-medium text-[#D0D0D0] break-all overflow-wrap-anywhere `}
          title={description}
        />
        <div className="mt-4">
          <NormalText
            title={description1}
            className={`text-sm ${btnResponsive(
              "text-sm"
            )} text-[#E0E0E0] mt-1`}
          />
        </div>
      </div>
      <div className="flexContainer justifyContent-center alignItems-center mt-4 height-100">
        <FooterComponent
          btnText1={btnText1}
          btnText={btnText}
          onCancel={onCancel}
          onTrigger={onTrigger}
          disabled={false}
        />
      </div>
    </div>
  );
};

export function shortenFilename(filename: any, count?: any) {
  let length = count || 80;
  if (filename.length > length) {
    return filename.slice(0, length - 3) + "...";
  }
  return filename;
}

export const deleteMultipleISOPopup = ({
  title,
  description,
  selectedItems,
  btnText1,
  btnText,
  onCancel,
  onTrigger,
  disabled = false,
}: {
  title: string;
  description?: string;
  selectedItems?: any[];
  btnText1?: string;
  btnText?: string;
  onCancel: () => void;
  onTrigger: () => void;
  disabled?: boolean;
}) => {
  return (
    <div className="flexContainer flexDirection-column w-[479px] xl-high:w-[550px]">
      <HeaderComponent title={title} onCancel={onCancel} />
      <div className="mt-4">
        <NormalText
          title={description}
          className={`text-xs ${btnResponsive(
            "text-xs"
          )} xl-high:!leading-[25px] font-medium text-[#D0D0D0]`}
        />
        <div className="overflow-auto mt-3 h-[120px]">
          <NormalText
            title={`${
              selectedItems?.map((i) => shortenFilename(i.name)).join(", ") ||
              ""
            }`}
            className={`text-xs break-all overflow-wrap-anywhere  ${btnResponsive(
              "text-xs"
            )} font-medium text-[#D0D0D0]`}
          />
        </div>
      </div>
      <div className="flexContainer justifyContent-center alignItems-center mt-4 height-100">
        <FooterComponent
          btnText1={btnText1}
          btnText={btnText}
          onCancel={onCancel}
          onTrigger={onTrigger}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
